// extracted by css-extract-rspack-plugin
export default {"row":"gSRj1"};